import React from 'react'
import { Helmet } from "react-helmet-async";
import EventContainer from "../../layouts/eventcontainer/eventContainer"; 
import { faGraduationCap } from '@fortawesome/free-solid-svg-icons';
import "./style.css";
import Pongal_1 from "../../../assets/images/gallery/2026/pongal celebrations/Pongal celebrations-1 (1).webp";
import Pongal_2 from "../../../assets/images/gallery/2026/pongal celebrations/Pongal celebrations-1 (2).webp";
import Pongal_3 from "../../../assets/images/gallery/2026/pongal celebrations/Pongal celebrations-1 (3).webp";
import Pongal_4 from "../../../assets/images/gallery/2026/pongal celebrations/Pongal celebrations-1 (4).webp";
import Pongal_5 from "../../../assets/images/gallery/2026/pongal celebrations/Pongal celebrations-1 (5).webp";
import Pongal_6 from "../../../assets/images/gallery/2026/pongal celebrations/Pongal celebrations-1 (6).webp";
import Pongal_7 from "../../../assets/images/gallery/2026/pongal celebrations/Pongal celebrations-1 (7).webp";
import Pongal_8 from "../../../assets/images/gallery/2026/pongal celebrations/Pongal celebrations-1 (8).webp";
import Pongal_9 from "../../../assets/images/gallery/2026/pongal celebrations/Pongal celebrations-1 (9).webp";

import TamilMandram_1 from "../../../assets/images/gallery/2026/Tamil mandram/Img  (1).jpeg";
import TamilMandram_2 from "../../../assets/images/gallery/2026/Tamil mandram/Img  (2).jpeg";
import TamilMandram_3 from "../../../assets/images/gallery/2026/Tamil mandram/Img  (3).jpeg";

import Campusdrive_1 from "../../../assets/images/gallery/2026/Placement/Image.jpeg";

import Motivational_1 from "../../../assets/images/gallery/2026/Motivational Speech Session/IMG (1).jpeg";
import Motivational_2 from "../../../assets/images/gallery/2026/Motivational Speech Session/IMG (2).jpeg";
import Motivational_3 from "../../../assets/images/gallery/2026/Motivational Speech Session/IMG (3).jpeg";

import Sportsday_1 from "../../../assets/images/gallery/2026/Sports day/IMG - (1).jpeg";
import Sportsday_2 from "../../../assets/images/gallery/2026/Sports day/IMG - (2).jpeg";
import Sportsday_3 from "../../../assets/images/gallery/2026/Sports day/IMG - (3).jpeg";
import Sportsday_4 from "../../../assets/images/gallery/2026/Sports day/IMG - (4).jpeg";
import Sportsday_5 from "../../../assets/images/gallery/2026/Sports day/IMG - (5).jpeg";
import Sportsday_6 from "../../../assets/images/gallery/2026/Sports day/IMG - (6).jpeg";

import Annuval_1 from "../../../assets/images/gallery/2026/annual day/Img (1).jpeg";
import Annuval_2 from "../../../assets/images/gallery/2026/annual day/Img (2).jpeg";
import Annuval_3 from "../../../assets/images/gallery/2026/annual day/Img (3).jpeg";
import Annuval_4 from "../../../assets/images/gallery/2026/annual day/Img (4).jpeg";
import Annuval_5 from "../../../assets/images/gallery/2026/annual day/Img (5).jpeg";
import Annuval_6 from "../../../assets/images/gallery/2026/annual day/Img (6).jpeg";
import Annuval_7 from "../../../assets/images/gallery/2026/annual day/Img (7).jpeg";
import Annuval_8 from "../../../assets/images/gallery/2026/annual day/Img (8).jpeg";
import Annuval_9 from "../../../assets/images/gallery/2026/annual day/Img (9).jpeg";

import Conference_1 from "../../../assets/images/gallery/2026/Conference/IMG (1).jpeg";
import Conference_2 from "../../../assets/images/gallery/2026/Conference/IMG (2).jpeg";
import Conference_3 from "../../../assets/images/gallery/2026/Conference/IMG (3).jpeg";
import Conference_4 from "../../../assets/images/gallery/2026/Conference/IMG (4).jpeg";
import Conference_5 from "../../../assets/images/gallery/2026/Conference/IMG (5).jpeg";
import Conference_6 from "../../../assets/images/gallery/2026/Conference/IMG (6).jpeg";
import Conference_7 from "../../../assets/images/gallery/2026/Conference/IMG (7).jpeg";



const Moments2026 = () => {
   const Event_1 =[
    {
        
            image:Pongal_1,
            altText: "",
            caption: "",
            id:"event-1",
        
    },
       {
        
            image:Pongal_2,
            altText: "",
            caption: "",
            id:"event-1",
        
    },
       {
        
            image:Pongal_3,
            altText: "",
            caption: "",
            id:"event-1",
        
    },
       {
        
            image:Pongal_4,
            altText: "",
            caption: "",
            id:"event-1",
        
    },
       {
        
            image:Pongal_5,
            altText: "",
            caption: "",
            id:"event-1",
        
    },
       {
        
            image:Pongal_6,
            altText: "",
            caption: "",
            id:"event-1",
        
    },
       {
        
            image:Pongal_7,
            altText: "",
            caption: "",
            id:"event-1",
        
    },
       {
        
            image:Pongal_8,
            altText: "",
            caption: "",
            id:"event-1",
        
    },
       {
        
            image:Pongal_9,
            altText: "",
            caption: "",
            id:"event-1",
        
    },
   ];
    const Event_2 =[
    {
        
            image:TamilMandram_1,
            altText: "",
            caption: "",
            id:"event-2",
        
    },
       {
        
            image:TamilMandram_2,
            altText: "",
            caption: "",
            id:"event-2",
        
    },
       {
        
            image:TamilMandram_3,
            altText: "",
            caption: "",
            id:"event-2",
        
    },
          ];
   const Event_3 =[
    {
        
            image: Campusdrive_1,
            altText: "",
            caption: "",
            id:"event-3",
        
    },
     
          ];
            const Event_4 =[
    {
        
            image: Motivational_1,
            altText: "",
            caption: "",
            id:"event-4",
        
    },
          {
        
            image: Motivational_2,
            altText: "",
            caption: "",
            id:"event-4",
        
    },
      {
        
            image: Motivational_3,
            altText: "",
            caption: "",
            id:"event-4",
        
    },
     
          ];

           const Event_5 =[
            {
        
            image: Sportsday_1,
            altText: "",
            caption: "",
            id:"event-5",
           },
             {
        
            image: Sportsday_2,
            altText: "",
            caption: "",
            id:"event-5",
           },
           {
            image: Sportsday_3,
            altText: "",
            caption: "",
            id:"event-5",
           },
            {
            image: Sportsday_4,
            altText: "",
            caption: "",
            id:"event-5",
           },
            {
            image: Sportsday_5,
            altText: "",
            caption: "",
            id:"event-5",
           },
            {
            image: Sportsday_6,
            altText: "",
            caption: "",
            id:"event-5",
           },
     
          ];
            const Event_6 =[
            {
        
            image: Annuval_1,
            altText: "",
            caption: "",
            id:"event-6",
           },
             {
        
            image: Annuval_2,
            altText: "",
            caption: "",
            id:"event-6",
           },
           {
            image: Annuval_3,
            altText: "",
            caption: "",
            id:"event-6",
           },
            {
            image: Annuval_4,
            altText: "",
            caption: "",
            id:"event-6",
           },
            {
            image: Annuval_5,
            altText: "",
            caption: "",
            id:"event-6",
           },
            {
            image: Annuval_6,
            altText: "",
            caption: "",
            id:"event-6",
           },
             {
            image: Annuval_7,
            altText: "",
            caption: "",
            id:"event-6",
           },
             {
            image: Annuval_8,
            altText: "",
            caption: "",
            id:"event-6",
           },
             {
            image: Annuval_9,
            altText: "",
            caption: "",
            id:"event-6",
           },
     
          ];
  
          const Event_7 =[
            {
        
            image: Conference_1,
            altText: "",
            caption: "",
            id:"event-7",
           },
             {
        
            image:Conference_2,
            altText: "",
            caption: "",
            id:"event-7",
           },
           {
            image: Conference_3,
            altText: "",
            caption: "",
            id:"event-7",
           },
            {
            image: Conference_4,
            altText: "",
            caption: "",
            id:"event-7",
           },
            {
            image: Conference_5,
            altText: "",
            caption: "",
            id:"event-7",
           },
            {
            image:Conference_6,
            altText: "",
            caption: "",
            id:"event-7",
           },
             {
            image:Conference_7,
            altText: "",
            caption: "",
            id:"event-7",
           },
            
           
     
          ];



  return (
   <>
     <Helmet>
        <title> Gallery-JNCW </title>
      </Helmet>

    <div className="container">
           <div class="text-center wow fadeInUp" data-wow-delay="0.1s">
                <h5 class="section-title bg-white text-center text-primary px-3">Gallery</h5>
                <h4 class="mb-5">JNCW-2026 Moments</h4>
            </div>
 <EventContainer
            data={Event_7}
            header="International Conference-2026"
            id="event-7"
            />
  <EventContainer
            data={Event_6}
            header="Annuval Day-2026"
            id="event-6"
            />
            <EventContainer
            data={Event_5}
            header="Sports Day 2k26"
            id="event-5"
            />
             <EventContainer
            data={Event_4}
            header="Motivational Speech Session – Commerce & BBA Department"
            id="event-4"
            />
 <EventContainer
            data={Event_3}
            header="JNCW Campus Drive"
            id="event-3"
            />
        

            <EventContainer
            data={Event_2}
            header="Tamil Mandram"
            id="event-2"
            />
        

      <EventContainer
            data={Event_1}
            header="Pongal Celebrations-2k26"
            id="event-1"
            />
         
            </div>

            
   </>


  );
};

export default Moments2026;